import { useIntl } from 'react-intl';

import { useIntlWrapperContext } from '../../../Helpers/IntlWrapperProvider';
import useObjectHelper from '../../../Helpers/useObjectHelper';
import {
	mentoringScopes,
	positions,
	pronouns,
	researchFields,
	titles,
} from '../../../Helpers/StaticData';

import {
	Action,
	FormPopupField,
} from '../../../components/Popup/FormPopup.model';

export const CurrentProfileConfigs = () => {
	const intl = useIntl();
	const { i18nCountries, i18nLanguages } = useIntlWrapperContext();
	const { arrToOptionList, objToOptionList } = useObjectHelper();

	const profileFields: { [key: string]: any } = [
		{
			id: 'firstName',
			layout: 'w50',
			rules: { required: true },
			type: 'text',
		},
		{
			id: 'lastName',
			layout: 'w50',
			rules: { required: true },
			type: 'text',
		},
		{
			id: 'title',
			layout: 'w25',
			options: { optionList: arrToOptionList(titles) },
			type: 'select',
		},
		{
			id: 'pronouns',
			layout: 'w25',
			options: { optionList: arrToOptionList(pronouns) },
			type: 'select',
		},
		{
			id: 'currentPosition',
			layout: 'w50',
			options: { optionList: arrToOptionList(positions) },
			type: 'select',
		},
		{
			id: 'languages',
			layout: 'w50',
			options: {
				optionList: objToOptionList(i18nLanguages),
				type: 'codeBased',
			},
			type: 'selectMultiple',
		},
		{
			id: 'location',
			layout: 'w50',
			options: {
				optionList: objToOptionList(i18nCountries),
				type: 'codeBased',
			},
			type: 'select',
		},
		{
			dependency: { id: 'role', value: 'Mentor' },
			id: 'mentoringScopes',
			layout: 'w100',
			options: { optionList: arrToOptionList(mentoringScopes) },
			type: 'selectMultiple',
		},
		{
			id: 'introduction',
			layout: 'w100',
			type: 'text-area',
		},
	];

	const workExperienceFields: FormPopupField[] = [
		{
			id: 'startDate',
			layout: 'w50',
			rules: { required: true },
			type: 'date',
		},
		{
			id: 'endDate',
			layout: 'w50',
			type: 'date',
		},
		{
			id: 'currentPosition',
			label: intl.formatMessage({ id: 'userLabels.position' }),
			layout: 'w50',
			options: { optionList: arrToOptionList(positions) },
			placeholder: intl.formatMessage({ id: 'formPlaceholders.position' }),
			rules: { required: true },
			type: 'select',
		},
		{
			id: 'institution',
			layout: 'w50',
			rules: { required: true },
			type: 'text',
		},
		{
			id: 'location',
			layout: 'w100',
			options: {
				optionList: objToOptionList(i18nCountries),
				type: 'codeBased',
			},
			rules: { required: true },
			type: 'select',
		},
		{
			id: 'description',
			layout: 'w100',
			rules: { required: true },
			type: 'textArea',
		},
	];

	const educationFields: FormPopupField[] = [
		{
			id: 'startDate',
			layout: 'w50',
			rules: { required: true },
			type: 'date',
		},
		{
			id: 'endDate',
			layout: 'w50',
			type: 'date',
		},
		{
			id: 'obtainedDegree',
			layout: 'w50',
			rules: { required: true },
			type: 'text',
		},
		{
			id: 'institution',
			layout: 'w50',
			rules: { required: true },
			type: 'text',
		},
		{
			id: 'location',
			layout: 'w100',
			options: {
				optionList: objToOptionList(i18nCountries),
				type: 'codeBased',
			},
			rules: { required: true },
			type: 'select',
		},
		{
			id: 'description',
			layout: 'w100',
			rules: { required: true },
			type: 'textArea',
		},
	];

	const articleFields: FormPopupField[] = [
		{
			id: 'authors',
			layout: 'w100',
			options: {
				optionList: arrToOptionList(['Anonymous']),
				type: 'codeBased',
			},
			rules: { required: true },
			type: 'tags',
		},
		{
			id: 'title',
			layout: 'w50',
			rules: { required: true },
			type: 'text',
		},
		{
			id: 'link',
			layout: 'w100',
			type: 'text',
		},
		{
			id: 'publishedIn',
			layout: 'w100',
			rules: { required: true },
			type: 'text',
		},
		{
			id: 'publishingLocation',
			layout: 'w50',
			options: {
				optionList: objToOptionList(i18nCountries),
				type: 'codeBased',
			},
			rules: { required: true },
			type: 'select',
		},
		{
			id: 'publishingYear',
			layout: 'w50',
			rules: { required: true },
			type: 'year',
		},
		{
			id: 'tags',
			layout: 'w100',
			options: {
				optionList: arrToOptionList(researchFields.map((rf) => intl.formatMessage({id: `researchAreas.${rf}`}))),
				type: 'codeBased',
			},
			rules: { required: true },
			type: 'tags',
		},
		{
			id: 'description',
			layout: 'w100',
			rules: { required: true },
			type: 'textArea',
		},
	];

	const formPupupActions: Action[] = [
		{
			onClick: () => {},
			title: 'cancel',
			type: 'default',
		},
		{
			isSubmitButton: true,
			title: 'save',
			type: 'primary',
		},
	];

	return {
		articleFields,
		educationFields,
		formPupupActions,
		i18nCountries,
		i18nLanguages,
		profileFields,
		researchFields,
		workExperienceFields,
	};
};

export default CurrentProfileConfigs;